import i18n from 'i18next';

i18n
  .init({
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },
    lng: 'en',
    resources: {
      en: {
        translation: {
          male: 'Male',
          female: 'Female',
          non_binary: 'Non-binary',
          n_a: 'Not Specified',
          greeting: "Hey, {{userName}}! You are doing well this month!",
          configureDashboard: 'Configure Dashboard',
          clientsGoal: {
            title: 'Clients Goal Month',
            current: 'Current',
            goal: 'Goal',
            left: 'Left'
          },
          incomeGoal: {
            title: 'Income Goal Month',
            current: 'Current',
            goal: 'Goal',
            left: 'Left'
          },
          workingHours: {
            title: 'Working Hours Goal',
            current: 'Current',
            goal: 'Goal',
            left: 'Left'
          },
          currentSpends: {
            title: 'Current Spends',
            monthlySpends: 'Spends',
            realIncome: 'Income',
          },
          suggestedCharge: {
            suggested: 'Suggested Hour Charge: {{suggestedCharge}}',
            average: 'Average Hour Charge: {{averageHourCharge}}',
            conclusion: 'You need to charge {{suggestedCharge}} for an hour if you want to work {{workingHours}} hours per month and reach your {{incomeGoal}} income goal.',
          },
          totalSpends: {
            totalIncome: 'Total Income (All Time)',
            totalSpends: 'Total Spends (All Time)',
            title: 'Comparison of spends and income in therapy',
          },
          clientsDemography: {
            children: 'Children (0-14)',
            teenagers: 'Teenagers (15-20)',
            youngAdults: 'Young Adults (21-29)',
            adults: 'Adults (30-50)',
            mature: 'Mature (50-64)',
            seniors: 'Seniors (65+)',
            title: 'Clients Demography',
          },
          clientSourcing: {
            title: 'Client Sourcing',
            socials: 'Social Networks',
            recs: 'Recommendation',
            ads: 'Ads',
            google: 'Google Search',
            notSpeced: 'Not Specified',
          },
          clientsGender: {
            title: 'Clients Demography By Gender',
          },
          generalInfo: {
            longestClient: 'Longest client in therapy: {{name}}, {{count}} appointments',
            oldestClient: 'Oldest client in therapy: {{name}}, {{count}} years',
            youngestClient: 'Youngest client in therapy: {{name}}, {{count}} years',
            workingHours: 'Most popular working hours: {{first}}, {{second}}, {{third}}',
            workingDay: 'Most popular working day: {{day}}',
            apptsCount: 'Overall appointments count: {{count}}',
            bestMonth: 'Best month: {{month}}, {{count}} appointments',
            laziestMonth: 'Laziest month: {{month}}, {{count}} appointments',
          }
        },
      },
      uk: {
        translation: {
          male: 'Чоловіки',
          female: 'Жінки',
          non_binary: 'Не бінарні',
          n_a: 'Немає даних',
          greeting: "Привіт, {{userName}}! Чудовий місяць!",
          configureDashboard: 'Налаштувати Статистику',
          clientsGoal: {
            title: 'Клієнти',
            current: 'Поточна кількість',
            goal: 'Ціль',
            left: 'До цілі'
          },
          incomeGoal: {
            title: 'Дохід',
            current: 'Поточна cума',
            goal: 'Ціль',
            left: 'До цілі'
          },
          workingHours: {
            title: 'Робочі Години',
            current: 'Поточна кількість',
            goal: 'Ціль',
            left: 'До цілі'
          },
          currentSpends: {
            title: 'Витрати/Доходи',
            monthlySpends: 'Витрати',
            realIncome: 'Доходи',
          },
          suggestedCharge: {
            suggested: 'Рекомендована ціна за сесію: {{suggestedCharge}}',
            average: 'Середня ціна за сесію: {{averageHourCharge}}',
            conclusion: 'Щоби працювати {{workingHours}} годин на місяць і заробити {{incomeGoal}}, рекомендована ціна становить {{suggestedCharge}} за сесію.',
          },
          totalSpends: {
            totalIncome: 'Загальний Дохід (за весь час)',
            totalSpends: 'Загальні Витрати (за весь час)',
            title: 'Порівняння доходів та витрат у терапії'
          },
          clientsDemography: {
            children: 'Діти (0-14)',
            teenagers: 'Підлітки (15-20)',
            youngAdults: 'Молодь (21-29)',
            adults: 'Дорослі (30-50)',
            mature: 'Зрілі (50-64)',
            seniors: 'Люди Похилого віку (65+)',
            title: 'Демографія Клієнтів',
          },
          clientSourcing: {
            title: 'Джерела Нових Клієнтів',
            socials: 'Соціальні мережі',
            recs: 'Особисті рекомендації',
            ads: 'Реклама',
            google: 'Google Пошук',
            notSpeced: 'Немає даних',
          },
          clientsGender: {
            title: 'Демографія клієнтів за статтю'
          },
          generalInfo: {
            longestClient: 'Найдовший клієнт у терапії: {{name}}, {{count}} сесій',
            oldestClient: 'Найстарший клієнт у терапії: {{name}}, {{age}} років',
            youngestClient: 'Наймолодший клієнт у терапії: {{name}}, {{age}} років',
            workingHours: 'Найпопулярніші години терапії: {{first}}, {{second}}, {{third}}',
            workingDay: 'Найпопулярніший день терапії: {{day}}',
            apptsCount: 'Кількість сесій за весь час: {{count}}',
            bestMonth: 'Найкращий місяць: {{month}}, {{count}} сесій',
            laziestMonth: 'Найлінивіший місяць: {{month}}, {{count}} сесій',
          },
        }
      }
    }
  })

export default i18n;
